import { connect } from 'react-redux'
import { loadJobsForDevice, reenqueueJob, cancelJob, passJob } from '../../../store/jobs'
import { getDevice } from '../../../store/devices'
import DeviceView from '../components/DeviceView'
import _ from 'lodash'
import { isUserStaff, isUserProvider } from '../../../lib/helpers'

const mapDispatchToProps = {
  loadJobsForDevice,
  reenqueueJob,
  cancelJob,
  getDevice,
  passJob
}

const mapStateToProps = (state, ownProps) => {
  let device = null
  if (_.size(state.devices) > 0) {
    device = state.devices[_.findIndex(state.devices, (d) => d.device_string === ownProps.params.device_string)]
  }
  return {
    jobs: _.filter(state.jobs, (job) => job.device_string === ownProps.params.device_string),
    isStaff: isUserStaff(state.user),
    isProvider: isUserProvider(state.user),
    device
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DeviceView)



// WEBPACK FOOTER //
// ./src/routes/Device/containers/DeviceContainer.js